import { SubstanceUomSetValue } from 'app/area/codetable/item/types-store';
import { CodeComplexValue } from 'app/area/shared/codetable/types';

export const mapToSubstanceUomSet = (uomSetCodes: CodeComplexValue<number>[]): SubstanceUomSetValue[] => uomSetCodes.map(code => ({
  uomSet: {
    value: code.value,
    description: code.description
  }
}));
